import { selectZoom } from 'modules/Editor/store/editorSettingsSelector';
import { store } from 'modules/Editor/store/store';
import { selectActiveWidgetSelectFrom, selectIsActiveWidget } from 'modules/Editor/store/widgetSelector';

import { PAGE_LINK_PREFIX } from './widgetSdk.config';

// Get the editor zoom level on demand
// E.g. if the zoom level is required outside of a react component where a hook (useEditor / useAppSelector) cannot be used
export const getEditorZoom = () => {
  const zoom = selectZoom(store.getState());
  return zoom;
};

// Get the selected state of a widget on demand
// E.g. if the selected state is required outside of a react component where a hook (useEditor / useAppSelector) cannot be used
export const getIsWidgetSelected = (widgetId: string) => {
  if (!widgetId) return false;

  const isWidgetSelected = selectIsActiveWidget(widgetId)(store.getState());
  return isWidgetSelected;
};

export const getActiveWidgetSelectFrom = () => {
  return selectActiveWidgetSelectFrom(store.getState());
};

/**
 * Check if a link is valid
 * - For page links, check if the page exists
 *
 * @param link link to check
 * @returns boolean - true if the link is valid, false otherwise
 */
export const checkIsValidLink = (link: string | undefined) => {
  if (!link) return false;

  const isPageLink = link.startsWith(PAGE_LINK_PREFIX);
  if (isPageLink) {
    const pageOrder = store.getState()?.infograph?.pageOrder;
    const pageId = link.replace(PAGE_LINK_PREFIX, '');
    return pageOrder?.includes(pageId);
  }

  // Other links are considered valid
  return true;
};
